/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_A11Inputs */

const en_job_form_enum_a11 = /** @type {(inputs: Job_Form_Enum_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A1 - Beginner`)
};

const de_job_form_enum_a11 = /** @type {(inputs: Job_Form_Enum_A11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A1 - Anfänger`)
};

/**
* | output |
* | --- |
* | "A1 - Beginner" |
*
* @param {Job_Form_Enum_A11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_a11 = /** @type {((inputs?: Job_Form_Enum_A11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_A11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_a11(inputs)
	return en_job_form_enum_a11(inputs)
});
export { job_form_enum_a11 as "job_form_enum_A1" }